<template>
  <div class="relative">
    <p class="text-red font-bold w-fit m-4 mx-auto text-2xl">{{$messageError ? $messageError : 'Lien non valide'}}</p>
  </div>
</template>

<script>
export default {
  name: 'ErrorView'
}
</script>

<style scoped></style>
